import { writable } from 'svelte/store';

const user = writable(null);

export { user };